module.exports = __webpack_public_path__ + "img/ONiAd-Academy-logotipo.be1422d6.png";